export default {"src":"/_next/static/media/logo.90e2d5eb.svg","height":462,"width":2348,"blurWidth":0,"blurHeight":0};